import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
const ListDatabasePage = loadable(() => import('./ListDatabasePage'), {
  fallback: <Loader />
});
const AddDatabasePage = loadable(() => import('./AddDatabasePage'), {
  fallback: <Loader />
});
const EditDatabasePage = loadable(() => import('./EditDatabasePage'), {
  fallback: <Loader />
});
const DatabaseRoutes = ({ t, setTabLoading , alert }) => {
  return [
    <Route
      key="database_list"
      exact
      path="/view/:projectId/database"
      element={<ListDatabasePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key="database_add"
      exact
      path="/view/:projectId/database/add"
      element={<AddDatabasePage t={t} alert={alert} />}
    />,
    <Route
      key="database_edit"
      exact
      path="/view/:projectId/database/:id/edit"
      element={<EditDatabasePage t={t} alert={alert} />}
    />
  ];
};
DatabaseRoutes.propTypes = {
  t: PropTypes.func
};
export default DatabaseRoutes;
